export default __webpack_public_path__ + "static/no-bs-seo-b251c4e1f117d9a8dded5738b8c0a633.png";